module.exports = __webpack_public_path__ + "images/emoji/couple_with_heart.97d631060ff6e11e52ee.png";